export default __webpack_public_path__ + "static/media/HW17_Cover-400x482.03a934b1.jpg";